var lib_core = require("lib-core");

/**
 * @constructor
 */
var UndoRedoStateMachine = function (root, model) {
    var self = this;
    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(this);

    // undo
    this.undoTransition = this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.UNDO_BUTTON || cEvent.isKeyPressed('C_z');
        },
        function(cEvent){
            self.root.undo();
        }, "Undo"
    );

    // redo
    this.redoTransition = this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.REDO_BUTTON || cEvent.isKeyPressed('C_y');
        },
        function(cEvent){
            self.root.redo();
        }, "Redo"
    );

};
lib_core.inherit(UndoRedoStateMachine, lib_core.StateMachine);

module.exports = UndoRedoStateMachine;
